import { getHeaders, getSaleApiConfig, includeCorsProxy, } from '../store/helpers';
const byNewestStart = (left, right) => Date.parse(right.startTime) - Date.parse(left.startTime);
export const fetchSaleData = async (loginConfig) => {
    const headers = await getHeaders(loginConfig);
    if (!headers)
        return;
    const { environment, company, accountSegment, posUnit } = getSaleApiConfig(loginConfig);
    const url = `https://api.npretail.app/${accountSegment}/${environment}/${company}/pos/sale/search?posunit=${posUnit}&withLines=true`;
    const proxiedUrl = includeCorsProxy(url);
    try {
        const requestUrl = loginConfig.isOnCloud ? url : proxiedUrl;
        const response = await fetch(requestUrl, {
            method: 'GET',
            headers,
        });
        // POS unit has no open sale
        if (response.status === 404)
            return { saleLines: [], paymentLines: [] };
        if (!response.ok) {
            throw new Error('Failed to fetch sale data');
        }
        const responseData = await response.json();
        if (Array.isArray(responseData)) {
            return responseData.sort(byNewestStart)[0] ?? null;
        }
        return responseData;
    }
    catch (err) {
        console.error('Error fetching sale data:', err);
        return null;
    }
};
const toPaymentLine = (line) => ({ ...line, id: line.lineId });
export const fetchFinishedSalePayments = async (loginConfig, receiptNo) => {
    const headers = await getHeaders(loginConfig);
    if (!headers)
        return null;
    const { environment, company, accountSegment, posUnit } = getSaleApiConfig(loginConfig);
    const url = `https://api.npretail.app/${accountSegment}/${environment}/${company}/pos/entry?posUnit=${posUnit}&documentNo=${encodeURIComponent(receiptNo)}&withLines=true`;
    try {
        const response = await fetch(loginConfig.isOnCloud ? url : includeCorsProxy(url), { method: 'GET', headers });
        if (!response.ok) {
            throw new Error('Failed to fetch finished sale');
        }
        const { data: entries } = await response.json();
        const finishedSale = entries[0];
        if (!finishedSale || finishedSale.entryType === 'Cancelled Sale')
            return null;
        return finishedSale.paymentLines.map(toPaymentLine);
    }
    catch (err) {
        console.error('Error fetching finished sale:', err);
        return null;
    }
};
